import { useEffect, useState } from 'react'

interface UseLoaderProps<T> {
  steps: T[]
  stopAtStep?: number
  showStep?: number
  intervalMs?: number
}

const STEP_TIMEOUT = 2000

export const useLoader = <T>({ showStep, stopAtStep, steps, intervalMs }: UseLoaderProps<T>) => {
  const [stepIndex, setStepIndex] = useState(0)
  const lastStep = stopAtStep && stopAtStep < steps.length ? stopAtStep : steps.length - 1

  useEffect(() => {
    if (typeof showStep === 'number') {
      setStepIndex(showStep)
      return
    }
    if (stepIndex === lastStep) {
      return
    }

    const interval = setInterval(() => {
      setStepIndex((prev) => {
        if (prev >= lastStep) {
          clearInterval(interval)
          return prev
        }
        return prev + 1
      })
    }, intervalMs || STEP_TIMEOUT)

    return () => clearInterval(interval)
  }, [stepIndex, showStep, intervalMs, lastStep])

  return stepIndex
}
